import React from "react";
import { message } from "antd";
import { CiCircleAlert } from "react-icons/ci";
import Instance from "../../AxiosConfig";

const DeleteVendorModal = ({ show, onClose, agentData, fetchData }) => {
  
  const handleDelete = async () => {
    try {
      const response = await Instance.delete(`agents/${agentData._id}`);

      if (response.status === 200 || response.status === 201) {
        message.success({
          content: "Agent deleted successfully!",
          duration: 3,
          className: "custom-agent-toast-wrapper",
        });
        onClose();
        fetchData();
      }
    } catch (error) {
      console.error(error);
      message.error(
        error.response?.data?.message || "Failed to delete agent."
      );
    }
  };

  if (!show) return null; // ✅ Only show when needed

  return (
    <div className="delete-modal-overlay" onClick={onClose}>
      <div className="delete-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="alert-content text-center">
          <CiCircleAlert className="alert-icon" />
          <h2>Are you sure?</h2>
          <p>Do you really want to delete this agent? This action cannot be undone.</p>
        </div>

        <div className="d-flex justify-content-around align-items-center gap-3 mt-4">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="delete-btn" onClick={handleDelete}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteVendorModal;
